import React, { useEffect, useState } from "react";
import { Modal, Upload, Steps, Button } from "antd";
import { InboxOutlined, UploadOutlined } from "@ant-design/icons";
import * as Minio from "minio";
import "./style/style.css";
import Datatable from "../../component/table/dataTable";
import xlsx from "xlsx";
import axios from "axios";
import request from "../../lib/requester";
import { Loader } from "react-overlay-loader";
const { Step } = Steps;

const { Dragger } = Upload;

const minioClient = new Minio.Client({
  endPoint: "s3.dexagroup.com",
  accessKey: "aam-traces",
  secretKey: "BkwJ0bdaNaSPl44tzxwC01Z6nsAM!U",
});

const UploadEBupotNew = () => {
  const [isLoading, setIsloading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [xlsxFile, setXlsxFile] = useState([]);
  const [xlsxData, setXlsxData] = useState(null);
  const [xlsxFileName, setXlsxFileName] = useState("");
  const [pdfFile, setPdfFile] = useState([]);
  const [pdfShowData, setPdfShowData] = useState([]);
  const [dataReview, setDataReview] = useState([]);
  const [uploadFileData, setUploadFileData] = useState([]);

  useEffect(() => {
    var result1 = xlsxFile.map((value) => {
      return {
        CLAIM_NUMBER: value.CLAIM_NUMBER,
        FILENAME: value.FILENAME.replace(/.pdf/g, ""),
        status: "",
        file: "",
      };
    });
    var result2 = pdfFile.map((value) => {
      return {
        FILENAME: value.name.replace(/:/g, "/").replace(/.pdf/g, ""),
        status: "",
        file: value,
      };
    });
    var result3 = result1.filter(function (o1) {
      return result2.some(function (o2) {
        o1.status = o1.FILENAME === o2.FILENAME ? "file not found" : "match";
        return o1.FILENAME === o2.FILENAME;
      });
    });

    var result4 = result1.filter(function (o1) {
      return !result2.some(function (o2) {
        o1.status = o1.FILENAME === o2.FILENAME ? "match" : "file not found";
        o1.file = o1.FILENAME === o2.FILENAME ? o2.file : "";
        return o1.FILENAME === o2.FILENAME;
      });
    });
    const merge = result3.concat(result4);
    setDataReview(merge);
  }, [xlsxFile, pdfFile]);

  const uploadXslx = async (e) => {
    setXlsxFileName(e.name);
    setIsloading(true);
    setXlsxData(e.fileList[0]);
    const f = e.file.originFileObj;
    const reader = new FileReader();
    let formData = new FormData();
    formData.append("fileUpload", f);

    reader.onload = async (e) => {
      var data = e.target.result;
      let readedData = xlsx.read(data, {
        type: "binary",
        cellDates: true,
        cellNF: false,
        cellText: false,
      });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataExcel = xlsx.utils.sheet_to_json(ws, {
        header: 0,
        raw: true,
        defval: null,
      });

      let message = "";
      const validate = () => {
        let valid = true;

        dataExcel.filter((value) => {
          if (!value["CLAIM NUMBER"]) {
            valid = false;
            message =
              "Pastikan nama header column sudah benar. CLAIM NUMBER dan FILE NAME";
          }
          if (!value["FILE NAME"]) {
            valid = false;
            message =
              "Pastikan nama header column sudah benar. CLAIM NUMBER dan FILE NAME";
          }

          if (value["FILE NAME"] !== null) {
            if (value["CLAIM NUMBER"] === null) {
              valid = false;
              message = "CLAIM NUMBER tidak boleh kosong";
            }
          }
          if (value["CLAIM NUMBER"] !== null) {
            if (value["FILE NAME"] === null) {
              valid = false;
              message = "FILE NAME tidak boleh kosong";
            }
          }
        });

        return valid;
      };

      if (validate()) {
        const maping = dataExcel.map((value, index) => {
          return {
            CLAIM_NUMBER: value["CLAIM NUMBER"],
            FILENAME: value["FILE NAME"],
          };
        });

        let url = "/api/traces/v1/claim/validate-claim-number";
        request.postTraces(url, maping, {
          success: function (response) {
            const res = response.data.data;
            const mapingRes = res.map((d, i) => {
              return {
                CLAIM_NUMBER: d.CLAIM_NUMBER,
                FILENAME: d.FILENAME,
                STATUS: d.VALID ? "Benar" : "Nomor Claim Tidak ada",
              };
            });
            setXlsxFile(mapingRes);
            setIsloading(false);
          },
          error: function (e) {
            setIsloading(false);
          },
        });
      } else {
        setIsloading(false);
        warning(message);
      }
    };

    reader.readAsBinaryString(f);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const upload = async () => {
    setIsloading(true);
    try {
      let url = "/api/traces/v1/claim/upload-bupot-flag";
      const maping = dataReview.map((d, i) => {
        return {
          CLAIM_NUMBER: d.CLAIM_NUMBER,
        };
      });

      const param = {
        CLAIM_NUMBER: maping,
        STATUS: "F",
      };
      await request.putTraces(url, param, {
        success: function (response) {
          const res = response.data;
        },
        error: function (e) {
          console.log(e);
        },
      });

      for (let i of dataReview) {
        let claim_no = i.CLAIM_NUMBER.split("-");
        const fileName = `/bukti-potong/CLAIM_${claim_no[1]}.pdf`;

        const minioUrl = await presignedUrl(fileName);
        const uploadFilePdf = await uploadToS3(minioUrl, i.file);
        setUploadFileData(uploadFileData.push(minioUrl.formData.key));
        if (uploadFilePdf?.status === 204) {
          const paramUpdate = {
            CLAIM_NUMBER: i.CLAIM_NUMBER,
            FILENAME: i.FILENAME.replace(/:/g, "/"),
            STATUS: "S",
            SOURCE: "arman",
          };
          await request.putTraces(url, paramUpdate, {
            success: function (response) {
              const res = response.data;
            },
            error: function (e) {
              console.log(e);
            },
          });
        }
      }

      const ext = xlsxData.name.split(".");
      var timestamp = new Date().getTime();
      const fileName = `/excel-multiupload/TEMPLATE_BUPOT_${timestamp}.${ext[1]}`;
      const minioUrl = await presignedUrl(fileName);
      const uploadFileXlsx = await uploadToS3(minioUrl, xlsxData);

      if (uploadFileXlsx?.status === 204) {
        setIsloading(false);
        success();
      }
    } catch (error) {
      setIsloading(false);
      warning();
    }
  };

  const success = () => {
    Modal.success({
      title: "Success",
      content: "Success Upload Bupot",
      onOk() {
        window.location.reload();
      },
    });
  };

  const warning = (message) => {
    Modal.warning({
      title: "Failed",
      content: message,
      onOk() {},
    });
  };

  const uploadToS3 = async (obj, file) => {
    try {
      const formData = new FormData();
      Object.entries(obj.formData).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append("file", file.originFileObj);

      return await axios.post(obj.postURL, formData);
    } catch (error) {
      console.log("upload s3 : ", error);
    }
  };

  const presignedUrl = async (fileName) => {
    try {
      // Construct a new postPolicy.
      const policy = minioClient.newPostPolicy();
      // Set the object name my-objectname.
      policy.setKey(fileName);
      // Set the bucket to my-bucketname.
      policy.setBucket("aam-traces");

      const expires = new Date();
      expires.setSeconds(24 * 60 * 60 * 10); // 10 days expiry.
      policy.setExpires(expires);
      return await minioClient.presignedPostPolicy(policy);
    } catch (error) {
      console.log(error);
    }
  };

  const steps = [
    {
      title: "Upload EXCEL",
      content: (
        <div>
          <div className="d-flex justify-content-center mb-4">
            <div className="w-50">
              <Upload
                name="xlsx"
                multiple={false}
                customRequest={() => false}
                onChange={(info) => {
                  uploadXslx(info);
                  setXlsxFile([]);
                }}
                showUploadList={false}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <Button icon={<UploadOutlined />}>Upload (Max: 1)</Button>
              </Upload>
              {xlsxFileName ? (
                <p
                  style={{
                    border: "1px solid #d9d9d9",
                    marginTop: "10px",
                    padding: "10px",
                  }}
                >
                  {xlsxFileName ? xlsxFileName : ""}
                </p>
              ) : null}
            </div>
            <div className="w-50">
              <Button onClick={() => handleDownloadTemplate()} type="primary">
                Download Template
              </Button>
            </div>
          </div>
          <div className="card card-info">
            <div className="card-body">
              <Datatable title="XLSX list" data={xlsxFile} />
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Upload PDF",
      content: (
        <div>
          <div className="d-flex justify-content-center mb-4">
            <div className="w-50">
              <Dragger
                name="pdf"
                fileList={[]}
                multiple={true}
                customRequest={() => false}
                accept="application/pdf"
                onChange={(info) => {
                  setPdfFile(info.fileList);
                }}
                showUploadList={false}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Drag or Drop PDF BUPOT Template File
                  <span className="text-danger">*</span>
                </p>
                <p className="ant-upload-hint">
                  Supported File : PDF File Only (.pdf)
                </p>
              </Dragger>
            </div>
          </div>
          <div className="card card-info">
            <div className="card-body">
              <Datatable
                hideColumn={[
                  "lastModified",
                  "lastModifiedDate",
                  "percent",
                  "size",
                  "uid",
                  "originFileObj",
                  "status",
                ]}
                title="PDF list"
                handleDelete={(record) => {
                  var filtered = pdfFile.filter(function (el) {
                    return el.name != record.name;
                  });
                  setPdfFile(filtered);
                }}
                data={pdfFile}
                filterButton={false}
              />
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Review",
      content: (
        <div className="card card-info">
          <div className="card-body">
            <Datatable
              filterButton={false}
              title="Review"
              data={dataReview}
              hideColumn={["file"]}
            />
          </div>
        </div>
      ),
    },
  ];

  const validate = () => {
    let valid = false;

    dataReview.filter((value, index) => {
      if (value.status != "match") {
        valid = true;
      }
    });
    if (xlsxData.length === 0) {
      valid = true;
    }
    if (pdfFile.length === 0) {
      valid = true;
    }

    return valid;
  };

  const xlsxValidate = () => {
    let valid = false;
    if (xlsxFile.length === 0) {
      valid = true;
    }
    xlsxFile.filter((value, index) => {
      if (value.STATUS != "Benar") {
        valid = true;
      }
    });
    return valid;
  };

  const handleDownloadTemplate = (e) => {
    const JSON_FOR_DOWNLOAD = [
      {
        "CLAIM NUMBER": null,
        "FILE NAME": null,
      },
    ];
    const workBook = xlsx.utils.book_new(); // create a new blank book
    const workSheet = xlsx.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
    xlsx.writeFile(workBook, "Template Multiupload Bupot.xlsx"); // initiate a file download in browser
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row ml-1">
            <div className="col-lg-12">
              <div className="card card-info">
                <div className="card-header">Multiupload E-bupot</div>
                <div className="card-body">
                  <Steps current={current}>
                    {steps.map((item) => (
                      <Step key={item.title} title={item.title} />
                    ))}
                  </Steps>
                  <div className="steps-content">{steps[current].content}</div>
                  <div className="steps-action">
                    {current > 0 && (
                      <Button
                        style={{
                          margin: "0 8px",
                        }}
                        onClick={() => prev()}
                      >
                        Previous
                      </Button>
                    )}
                    {current < steps.length - 1 && (
                      <Button
                        disabled={xlsxValidate()}
                        type="primary"
                        onClick={() => next()}
                      >
                        Next
                      </Button>
                    )}
                    {current === steps.length - 1 && (
                      <Button
                        disabled={validate()}
                        type="primary"
                        onClick={() => upload()}
                      >
                        Upload
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Loader fullPage loading={isLoading} />
    </div>
  );
};

export default UploadEBupotNew;
